import { render, staticRenderFns } from "./ws-downfile.vue?vue&type=template&id=0427114b&scoped=true"
import script from "./ws-downfile.vue?vue&type=script&lang=js"
export * from "./ws-downfile.vue?vue&type=script&lang=js"
import style0 from "./ws-downfile.vue?vue&type=style&index=0&id=0427114b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0427114b",
  null
  
)

export default component.exports